//@flow
import React from 'react';
import _ from 'underscore';
import HeapActions from '../../Actions/heap';

export default class ScrollListener extends React.PureComponent<{}> {
  _trackScroll:() => void;
  scrollTwentyFive:boolean;
  scrollFifty:boolean;
  scrollSeventyFive:boolean;
  scrollOneHundred:boolean;

  constructor() {
    super();

    this.scrollTwentyFive = false;
    this.scrollFifty = false;
    this.scrollSeventyFive = false;
    this.scrollOneHundred = false;

    this._trackScroll = _.throttle(this._trackScroll, 200);
  }

  componentDidMount() {
    window.addEventListener('scroll', this._trackScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this._trackScroll);
  }

  _trackScroll() {
    const scrollEl = document.body;
    if (!scrollEl) return;
    const scrollHeight = scrollEl.scrollHeight - window.innerHeight;
    const scrollPercent = (scrollHeight == 0) ? 0 : (scrollEl.scrollTop / scrollHeight) * 100;

    if (scrollPercent >= 25 && !this.scrollTwentyFive) {
      HeapActions.trackScroll({ percent: 25 });
      this.scrollTwentyFive = true;
    }

    if (scrollPercent >= 50 && !this.scrollFifty) {
      HeapActions.trackScroll({ percent: 50 });
      this.scrollFifty = true;
    }

    if (scrollPercent >= 75 && !this.scrollSeventyFive) {
      HeapActions.trackScroll({ percent: 75 });
      this.scrollSeventyFive = true;
    }

    if (scrollPercent >= 100 && !this.scrollOneHundred) {
      HeapActions.trackScroll({ percent: 100 });
      this.scrollOneHundred = true;
    }
  }

  render() {
    return null;
  }
}
